import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { v4 as UUID } from 'uuid';

import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';

import { Models } from '@ibexfusion/models';
import { ScreenService } from '@services/screens/screen.service';
import { RedirectService } from '@services/redirects/redirect.service';

@Component({
    selector: 'app-redirect-edit',
    templateUrl: './redirect-edit.component.html',
    styleUrls: ['./redirect-edit.component.scss'],
    providers: [ScreenService, RedirectService],
    standalone: false
})
export class RedirectEditComponent implements OnInit {

  isLoading = false;

  title = '';

  subtitle = '';

  screenName = '';

  redirect: Models.Redirect = new Models.Redirect();

  public myForm: UntypedFormGroup;

  isCreateDialog;

  pageActions = [];

  public lat: number;
  public long: number;
  public description: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private screenService: ScreenService,
    private redirectService: RedirectService,
    private formBuilder: UntypedFormBuilder,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.isCreateDialog = false;

    // Change an existing redirect entry
    if (this.route.snapshot.params['id']) {
      this.redirectService.get(this.route.snapshot.params['id']).then(response => {
        this.redirect = response;
        this.title = 'Edit Redirect: ' + this.redirect.title;
        this.isLoading = false;
        if (this.redirect.location && this.redirect.location.coordinates) {
          this.lat = this.redirect.location.coordinates[0];
          this.long = this.redirect.location.coordinates[1];
        }
        this.description = '';
        if (this.redirect.detail && this.redirect.detail.description) {
          this.description = this.redirect.detail.description;
        }

        return this.screenService.find(0, 1, { uuid: this.redirect.screenUUID }).then(responseScreen => {
          this.screenName = responseScreen.data[0].remark;
          this.subtitle = 'Screen: ' + this.screenName;
          this.isLoading = false;
        });

      });

      // Add a new redirect to screen
    } else if (this.route.snapshot.params['screenId']) {

      this.isCreateDialog = true;
      this.title = 'Create New Redirect';
      this.redirect.screenUUID = this.route.snapshot.params['screenId'];
      return this.screenService.find(0, 1, { uuid: this.redirect.screenUUID }).then(responseScreen => {
        this.screenName = responseScreen.data[0].remark;
        this.subtitle = 'Screen: ' + this.screenName;
        this.isLoading = false;
      });

      // Add a new redirect manually
    } else {

      this.isCreateDialog = true;
      this.title = 'Create New Redirect';
      this.isLoading = false;
    }
    this.createPageActions();
  }

  public submit() {
    if (this.long && this.lat) {
      this.redirect.location = new Models.RedirectLocation();
      this.redirect.location.populateFromJSON({ type: 'Point', coordinates: [this.long, this.lat] });
    }
    this.redirect.detail = { description: this.description };
    if (this.isCreateDialog) {
      this.performCreateRedirectAction();
    } else {
      this.performEditRedirectAction();
    }
  }

  private buildForm(): void {
    this.myForm = this.formBuilder.group({});
  }

  private performCreateRedirectAction() {
    this.redirect.uuid = UUID();
    this.redirectService.create(this.redirect).then(() => {
      this.snackbar.success('Redirect created');
      this.router.navigate(['redirects']);
    }, error => {
      this.snackbar.error('Failed');
      console.error(error);
    });

  }

  private performEditRedirectAction() {
    this.redirectService.update(this.route.snapshot.params['id'], this.redirect).then(() => {
      this.snackbar.success('Redirect updated');
      this.router.navigate(['redirects']);
    }, error => {
      this.snackbar.error('Failed');
      console.error(error);
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview Redirect',
        callback: () => {
          this.router.navigate(['redirects']);
        }
      })
    ];
    if (!this.isCreateDialog) {
      this.pageActions.push(
        new PageAction({
          icon: 'transform',
          title: 'Detail Redirect',
          callback: () => {
            this.router.navigate(['redirects/', this.route.snapshot.params['id']]);
          }
        })
      );
    }
  }
}
